import Store from "App/Store.js";

export default props => Store.dispatch({type: "set", props});
